module.exports = __webpack_public_path__ + "21b0aa2941094bd7f6d29bb9ad770f2e.MP3";